import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { z } from "zod";

import commonEn from "@/locales/en/common.json";
import globalBlockListEn from "@/locales/en/system/globalBlockList.json";
import emailInboxSettingsEn from "@/locales/en/system/emailInboxSettings.json";
import addonsOverviewEn from "@/locales/en/system/addonsOverview.json";
import workflowsListEn from "@/locales/en/system/workflowsList.json";
import importTemplatesEn from "@/locales/en/system/importTemplates.json";
import userBehaviorLogsEn from "@/locales/en/system/userBehaviorLogs.json";
import profundoIntegrationEn from "@/locales/en/system/profundoIntegration.json";
import hubspotIntegrationEn from "@/locales/en/system/hubspotIntegration.json";
import teamsIntegrationEn from "@/locales/en/system/teamsIntegration.json";
import smsInboxEn from "@/locales/en/customers/smsInbox.json";
import emailInboxEn from "@/locales/en/customers/emailInbox.json";
import customerStateEn from "@/locales/en/campaigns/customerState.json";
import outcomesReportEn from "@/locales/en/campaigns/outcomesReport.json";
import productsReportEn from "@/locales/en/campaigns/productsReport.json";
import openOffersReportEn from "@/locales/en/campaigns/openOffersReport.json";
import campaignLayoutEn from "@/locales/en/campaigns/layout.json";
import hitrateInsightsEn from "@/locales/en/campaigns/hitrateInsights.json";
import customerManagementEn from "@/locales/en/campaigns/customer_management.json";
import customerSatisfactionEn from "@/locales/en/campaigns/customerSatisfaction.json";
import customerSatisfactionReportEn from "@/locales/en/campaigns/customerSatisfactionReport.json";
import dataOwnerCustomerManagementEn from "@/locales/en/dataOwners/customerManagement.json";
import dataOwnerCustomerStateEn from "@/locales/en/dataOwners/customerState.json";
import dataOwnerLayoutEn from "@/locales/en/dataOwners/layout.json";
import teamsLayoutEn from "@/locales/en/teams/layout.json";
import usersLayoutEn from "@/locales/en/users/layout.json";
import loginEn from "@/locales/en/auth/login.json";
import welcomeHomeEn from "@/locales/en/welcome/home.json";
import customerEventsReportEn from "@/locales/en/customerEventsReport.json";

import commonNb from "@/locales/nb/common.json";
import globalBlockListNb from "@/locales/nb/system/globalBlockList.json";
import emailInboxSettingsNb from "@/locales/nb/system/emailInboxSettings.json";
import addonsOverviewNb from "@/locales/nb/system/addonsOverview.json";
import workflowsListNb from "@/locales/nb/system/workflowsList.json";
import importTemplatesNb from "@/locales/nb/system/importTemplates.json";
import userBehaviorLogsNb from "@/locales/nb/system/userBehaviorLogs.json";
import profundoIntegrationNb from "@/locales/nb/system/profundoIntegration.json";
import hubspotIntegrationNb from "@/locales/nb/system/hubspotIntegration.json";
import teamsIntegrationNb from "@/locales/nb/system/teamsIntegration.json";
import smsInboxNb from "@/locales/nb/customers/smsInbox.json";
import emailInboxNb from "@/locales/nb/customers/emailInbox.json";
import customerStateNb from "@/locales/nb/campaigns/customerState.json";
import outcomesReportNb from "@/locales/nb/campaigns/outcomesReport.json";
import productsReportNb from "@/locales/nb/campaigns/productsReport.json";
import openOffersReportNb from "@/locales/nb/campaigns/openOffersReport.json";
import campaignLayoutNb from "@/locales/nb/campaigns/layout.json";
import hitrateInsightsNb from "@/locales/nb/campaigns/hitrateInsights.json";
import customerManagementNb from "@/locales/nb/campaigns/customer_management.json";
import customerSatisfactionNb from "@/locales/nb/campaigns/customerSatisfaction.json";
import customerSatisfactionReportNb from "@/locales/nb/campaigns/customerSatisfactionReport.json";
import dataOwnerCustomerManagementNb from "@/locales/nb/dataOwners/customerManagement.json";
import dataOwnerCustomerStateNb from "@/locales/nb/dataOwners/customerState.json";
import dataOwnerLayoutNb from "@/locales/nb/dataOwners/layout.json";
import teamsLayoutNb from "@/locales/nb/teams/layout.json";
import usersLayoutNb from "@/locales/nb/users/layout.json";
import loginNb from "@/locales/nb/auth/login.json";
import welcomeHomeNb from "@/locales/nb/welcome/home.json";
import customerEventsReportNb from "@/locales/nb/customerEventsReport.json";

export const defaultNS = "common";

export const resources = {
  en: {
    common: commonEn,
    system: {
      globalBlockList: globalBlockListEn,
      emailInboxSettings: emailInboxSettingsEn,
      addonsOverview: addonsOverviewEn,
      workflowsList: workflowsListEn,
      importTemplates: importTemplatesEn,
      userBehaviorLogs: userBehaviorLogsEn,
      profundoIntegration: profundoIntegrationEn,
      hubspotIntegration: hubspotIntegrationEn,
      teamsIntegration: teamsIntegrationEn,
    },
    customers: {
      smsInbox: smsInboxEn,
      emailInbox: emailInboxEn,
    },
    campaigns: {
      customerState: customerStateEn,
      outcomesReport: outcomesReportEn,
      productsReport: productsReportEn,
      openOffersReport: openOffersReportEn,
      layout: campaignLayoutEn,
      hitrateInsights: hitrateInsightsEn,
      customer_management: customerManagementEn,
      customerSatisfaction: customerSatisfactionEn,
      customerSatisfactionReport: customerSatisfactionReportEn,
    },
    dataOwners: {
      customerManagement: dataOwnerCustomerManagementEn,
      customerState: dataOwnerCustomerStateEn,
      layout: dataOwnerLayoutEn,
    },
    teams: {
      layout: teamsLayoutEn,
    },
    users: {
      layout: usersLayoutEn,
    },
    auth: {
      login: loginEn,
    },
    welcome: {
      home: welcomeHomeEn,
    },
    customerEventsReport: customerEventsReportEn,
  },
  nb: {
    common: commonNb,
    system: {
      globalBlockList: globalBlockListNb,
      emailInboxSettings: emailInboxSettingsNb,
      addonsOverview: addonsOverviewNb,
      workflowsList: workflowsListNb,
      importTemplates: importTemplatesNb,
      userBehaviorLogs: userBehaviorLogsNb,
      profundoIntegration: profundoIntegrationNb,
      hubspotIntegration: hubspotIntegrationNb,
      teamsIntegration: teamsIntegrationNb,
    },
    customers: {
      smsInbox: smsInboxNb,
      emailInbox: emailInboxNb,
    },
    campaigns: {
      customerState: customerStateNb,
      outcomesReport: outcomesReportNb,
      productsReport: productsReportNb,
      openOffersReport: openOffersReportNb,
      layout: campaignLayoutNb,
      hitrateInsights: hitrateInsightsNb,
      customer_management: customerManagementNb,
      customerSatisfaction: customerSatisfactionNb,
      customerSatisfactionReport: customerSatisfactionReportNb,
    },
    dataOwners: {
      customerManagement: dataOwnerCustomerManagementNb,
      customerState: dataOwnerCustomerStateNb,
      layout: dataOwnerLayoutNb,
    },
    teams: {
      layout: teamsLayoutNb,
    },
    users: {
      layout: usersLayoutNb,
    },
    auth: {
      login: loginNb,
    },
    welcome: {
      home: welcomeHomeNb,
    },
    customerEventsReport: customerEventsReportNb,
  },
} as const;

const configureZodLocale = (language: string) => {
  if (language === "nb") {
    z.config(z.locales.no());
  } else {
    z.config(z.locales.en());
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  defaultNS,
  returnNull: false,
  ns: [
    "common",
    "system",
    "customers",
    "campaigns",
    "dataOwners",
    "teams",
    "users",
    "auth",
    "welcome",
    "customerEventsReport",
  ],
  nsSeparator: ":",
  keySeparator: ".",
  interpolation: {
    escapeValue: false, // React already handles XSS
  },
});

configureZodLocale(i18n.language);

i18n.on("languageChanged", (lng) => {
  configureZodLocale(lng);
});

export default i18n;
